import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_STA003_Request,
  IAPI_STA003_Response,
  IAPI_STA008_Request,
  IAPI_STA008_Response,
  IAPI_BUS001_Request,
  IAPI_BUS001_Response,
} from "../../../type/apiType";

// 退職者情報詳細参照
const httpAPI_STA003 = async (
  param: IAPI_STA003_Request
): Promise<IAPI_STA003_Response> => {
  let res = await http.post(ApiUrl.API_STA003, {
    ...param,
  });

  return res.data;
};

// 退職者詳細情報更新
const httpAPI_STA008 = async (
  param: IAPI_STA008_Request
): Promise<IAPI_STA008_Response> => {
  let res = await http.post(ApiUrl.API_STA008, {
    ...param,
  });

  return res.data;
};

// 退職日の整合性チェック
const httpAPI_BUS001 = async (
  param: IAPI_BUS001_Request
): Promise<IAPI_BUS001_Response> => {
  let res = await http.post(ApiUrl.API_BUS001, {
    ...param,
  });

  return res.data;
};

export { httpAPI_STA003, httpAPI_STA008, httpAPI_BUS001 };
